import {AfterViewInit, Component, ViewChild, ViewContainerRef} from "@angular/core";

import {ICellEditorAngularComp} from "ag-grid-angular";

@Component({
    selector: 'app-numeric-cell',
    template: `<input #input  [(ngModel)]="value" style="width: 100%" required class="form-control" maxlength=4 placeholder="CCYY">`
})
export class YearEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: number;
    private cancelBeforeStart = false;

    @ViewChild('input', {read: ViewContainerRef}) public input;


    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
         // only start edit if key pressed is a number, not a letter
        this.cancelBeforeStart = params.charPress && ('12'.indexOf(params.charPress) < 0);
       
    }

    getValue(): any {
        return this.value;
    }

    isCancelBeforeStart(): boolean {
        return this.cancelBeforeStart;
    }

    // will reject the year if it greater than current year and less than 100 years for current year
    
    isCancelAfterEnd(): boolean {
        // const currentYear=(new Date()).getFullYear()
        // const less100Years=currentYear-100;
        // return !((this.value <= currentYear) && (this.value>less100Years));
        return false;
    };

    

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.input.element.nativeElement.focus();
        })
    }

    onKeyDown(event): void {
        
        if (!this.isKeyPressedNumeric(event)) {
            
            if (event.preventDefault){
                event.preventDefault();
            } 
        }
    }

    private getCharCodeFromEvent(event): any {
        event = event || window.event;
        return (typeof event.which === "undefined") ? event.keyCode : event.which;
    }

    private isCharNumeric(charStr): boolean {
        return !!/\d/.test(charStr);
    }

    private isKeyPressedNumeric(event): boolean {
        const charCode = this.getCharCodeFromEvent(event);
        const charStr = event.key ? event.key : String.fromCharCode(charCode);
        if(charStr==="Backspace" || charStr==="Delete")
        {
            return true;
        }
       if(this.isCharNumeric(charStr))
       {
        return true;
       }
       
    }
   
}


// WEBPACK FOOTER //
// ./src/app/shared/components/year-editor.component.ts